import {Table, Column} from "@appkit4/react-components/table";
import { useState, useEffect, React } from "react";
import "../../../../src/styles/userManagement.css";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";
import {Modal} from "@appkit4/react-components/modal"
import EditUsersModal from "./editUsersModal";

const EditUsers = () => {
    const [tableData, setTableData] = useState([]);
    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState([]);
    const [current, setCurrent] = useState(1);
    const [totalPage, setTotalPage] = useState(500);
    const [visible, setVisible] = useState(false);
    const [userData, setUserData] = useState({});
    const { sendRequest: getUsersListEdit } = useHttp();

    useEffect (() => {
        fetchUserList();
    }, []);

    useEffect(() => {
        const result = tableData?.filter((userList) => {
          return userList.email_id.toLowerCase().match(search.toLocaleLowerCase());
        });
        setFilter(result);
        let totalPageLength = Math.ceil((result.length)/10);
            if (totalPageLength === 0) {
              totalPageLength = 1;
            }
            setTotalPage(totalPageLength);
      }, [search]);

    const fetchUserList = () => {
        getUsersListEdit(APIService.getUsersListEdit(), responseHandler, errorHandler);
    }

    const responseHandler = (result) => {
        if (result.CODE) {
            setTableData(result.MSG);
            setFilter(result.MSG);
            let totalPageLength = Math.ceil((result.MSG.length)/10);
            if (totalPageLength === 0) {
              totalPageLength = 1;
            }
            setTotalPage(totalPageLength);
          }
          else {
            displayToastMessage("Something went wrong, Please try again!", "error")
          }
    }

    const errorHandler = () => {
        displayToastMessage("Something went wrong, Please try again!", "error");
      }

      const sortFuncForOrder1 = (a, b) => {
        const firstOrderId = (a.first_name).charAt(1);
        const secondOrderId = (b.first_name).charAt(1);
        return firstOrderId > secondOrderId ? 1 : -1;;
    }
    
    const sortFuncForOrder2 = (a, b) => {
        const firstOrderId = (a.first_name).charAt(1);
        const secondOrderId = (b.first_name).charAt(1);
        return firstOrderId < secondOrderId ? 1 : -1;;
    }

    const renderActionCell = (row) => {
        return(
          <span className="Appkit4-icon icon-edit-fill action-icon pointer" title="Edit User" onClick={() => handleClick(row)}></span>
        )
      }

      const handleClick = (row) => {
        setVisible(true);
        setUserData({
            firstName: row?.first_name,
            lastName: row?.last_name,
            userPhone: row?.user_phone,
            emailID: row?.email_id,
            userID: row?.user_id
        });
      }

      const handleCancel = () => {
        setVisible(false);
        setUserData({});
      }

      return (
        <div className="App">
            <div className="col-lg-12 mt-3 pl-1">
            <div className="ap-table-demo menu-tableAlignment-width">
              {tableData.length > 0 ? (
                <Input
                type="text"
                title= "Search Email ID"
                value={search}
                className="ap-field-wrapper-tableSearch"
                onChange={(e) => setSearch(e)}
              /> 
              ) : ""}
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10}>
                    <Column field="first_name" sortKey={filter.length > 0 ? "first_name" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2}>First Name</Column>
                    <Column field="last_name" sortKey={filter.length > 0 ? "last_name" : ""}>Last Name</Column>
                    <Column field="email_id" sortKey={filter.length > 0 ? "email_id" : ""}>Email ID</Column>
                    <Column field="user_phone" sortKey={filter.length > 0 ? "user_phone" : ""}>User Phone</Column>
                    <Column field="user_id"
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
            </div>
            <div>
              <Modal
              className="baseline-modal-showcase"
              visible={visible}
              onCancel={handleCancel}
              title={"Edit user"}
              bodyStyle={{maxHeight:"500px"}}
              footerStyle={{paddingTop:"8px", marginTop: "100px"}}
              modalStyle={{width:"49.75rem", maxHeight:"500px"}}
              >
                <EditUsersModal userData={userData} setVisible={setVisible} handleCancel={handleCancel} setUserData={setUserData} fetchUserList={fetchUserList} setSearch={setSearch}/>
              </Modal>
            </div>
        </div>
      )
}

export default EditUsers;